import * as Immutable from "immutable";
import { BaseEntity } from "../../baseEntity";
import { ConfInfo } from ".";
import { RuleInfo } from "..";

export class DisallowedInfo extends BaseEntity {

  protected readonly CONF_INFO = "confInfo";
  protected readonly RULE_INFOS = "ruleInfos";

  get confInfo(): ConfInfo { return this.getInternalValue<ConfInfo>(this.CONF_INFO); }
  setConfInfo(confInfo: ConfInfo): this { return this.setInternalValue(this.CONF_INFO, confInfo); }

  get ruleInfos(): Immutable.List<RuleInfo> { return this.getInternalValue<Immutable.List<RuleInfo>>(this.RULE_INFOS); }
  setRuleInfos(ruleInfos: Immutable.List<RuleInfo>): this { return this.setInternalValue(this.RULE_INFOS, ruleInfos); }
}